export default __webpack_public_path__ + "static/media/mars.c9064df9.jpg";